import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';
import Button from '@mui/material/Button';
import { Download } from '@mui/icons-material';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { APIClient } from '../../../helpers/api_helper';
import * as url from '../../../helpers/url_helper';

const apiClient = new APIClient();

export function GenerarPagare() {

    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [formData, setFormData] = useState({
        creditId: "",
        documento: ""
    });
    const [isOpenProgress, setIsOpenProgress] = useState(false);
    const [urlFile, setUrlFile] = useState('');
    const [viewBtnDownload, setViewBtnDownload] = useState(false);

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const handleCleanformData = () => {
        setFormData({
            creditId: "",
            documento: ""
        });
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = async (e) => {
        handleClearStateAlert();
        setViewBtnDownload(false);
        e.preventDefault();

        if (formData.creditId.length === 0 || formData.documento.length === 0) {
            handleOpenAlert('error', 'Por favor rellene los campos del formulario', true);
            return;
        }

        setIsOpenProgress(true);
        try {
            let response = await apiClient.create(url.GENERATE_PAGARE, formData);
            if (response.status !== 200) {
                handleOpenAlert('error', response.data?.message, true);
                return;
            }
            setIsOpenProgress(false);
            handleOpenAlert('success', response.data?.message, true);
            let urlFile = response.data?.data?.url;
            setUrlFile(urlFile);
            setViewBtnDownload(true);
            handleCleanformData();
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error.message, true);
        }finally {
            setIsOpenProgress(false);
        }
        setTimeout(() => {
            handleClearStateAlert()
        }, 6000);
    }

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
    }, [])

    return (
        <Fragment>
            {
                viewalert ?
                    <>
                        <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                        <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                    </>
                    : <></>
            }

            <DashboardsBackOffice
                name={'Admin'}
                balance={0}
                current13={true}
                title={'Generar pagaré de crédito'}
                main={
                    <>
                        <form action="#" method="POST">
                            <div className='px-4 mt-3 py-5 bg-white sm:p-6' style={{ borderRadius: '5px', height: '400px' }}>

                                <div className="col-span-8 sm:col-span-4">
                                    <label
                                        htmlFor="CreditId"
                                        className="block text-sm font-medium"
                                    >
                                        Id crédito
                                    </label>
                                    <div>
                                        <input
                                            value={formData.creditId}
                                            onChange={handleChange}
                                            type="text"
                                            name="creditId"
                                            id="creditId"
                                            maxLength="40"
                                            className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                        />
                                    </div>
                                    <span
                                        className="text-sm"
                                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                                    >
                                        {''}
                                    </span>
                                </div>


                                <div className="col-span-8 sm:col-span-4 mt-4">
                                    <label
                                        htmlFor="documento"
                                        className="block text-sm font-medium"
                                    >
                                        No. Documento
                                    </label>
                                    <div>
                                        <input
                                            value={formData.documento}
                                            onChange={handleChange}
                                            type="number"
                                            name="documento"
                                            id="documento"
                                            maxLength="40"
                                            className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                        />
                                    </div>
                                </div>

                                {
                                    isOpenProgress ?
                                        <Fragment>
                                            <div className="w-full pt-3 mt-3 row flex justify-center">
                                                <CircularProgress size={50} />

                                            </div>
                                            <div className="w-full pt-3 mt-3 row flex justify-center">
                                                <span>Generando pagaré...</span>
                                            </div>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <div className='w-full flex justify-center'>
                                                <div className="md:w-56 pt-3 mt-3">
                                                    <button
                                                        onClick={handleSubmit}
                                                        type="button"
                                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                                    >
                                                        <div className="flex">
                                                            {'Generar pagaré'}
                                                            <div className="grid content-center pl-2">{ }</div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>

                                            {
                                                viewBtnDownload && urlFile && (
                                                    <div className='w-full flex justify-center'>
                                                        <div className="pt-3" style={{ marginTop: '5rem' }}>
                                                            <Stack direction="row" spacing={2}>
                                                                <a href={urlFile} target="_blank" rel="noopener noreferrer">
                                                                    <Button variant="contained" startIcon={<Download />} onClick={() => {
                                                                        setUrlFile('');
                                                                        setViewBtnDownload(false);
                                                                    }}>
                                                                        Descargar documento
                                                                    </Button>
                                                                </a>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Fragment>
                                }

                            </div>
                        </form>

                    </>
                }
            />

        </Fragment>
    );
}
